import {
  getScreenFromRoute,
  trackEvent,
  trackScreenView,
} from 'modules/analytics';

export const languageSelectorClicked = (locale: string) => {
  trackEvent(
    null,
    {
      eventCategory: 'Language Settings',
      eventAction: 'Language Settings Dropdown',
      eventLabel: locale,
    },
    { providers: [ga] }
  );
};

export const languageModalSelectorViewed = () => {
  trackScreenView('language_selector_modal', {
    location: getScreenFromRoute(window.location.pathname),
  });
};

export const languageModalSelectorViewedGA = () => {
  if (window.ga !== undefined) {
    // TODO https://anchorfm.atlassian.net/browse/WHEEL-807: Find Solution Without Utilizing GA Global Object
    window.ga('send', 'pageview', 'Choose a language modal');
  }
};

export const languageButtonClicked = (newLocale: string) => {
  trackEvent(
    'language_button_clicked',
    {
      location: getScreenFromRoute(window.location.pathname),
      detected_language: window.navigator.language, // eslint-disable-line camelcase
      current_language: newLocale, // eslint-disable-line camelcase
    },
    { providers: [mParticle] }
  );
};
export const languageButtonClickedGA = (newLocale: string) => {
  trackEvent(
    null,
    {
      eventCategory: 'Language Settings',
      eventAction: 'Language Selected',
      eventLabel: newLocale,
    },
    { providers: [ga] }
  );
};
